import React, { Component } from "react";

import Game from "./container/Game";

class App extends Component {
  render() {
    return <Game className="game" />;
  }
}

export default App;
